import { useMemo, useState, useEffect } from 'react'
import styled, { css } from 'styled-components'

// types
interface ITrainerPhotoProps {
  trainerEmployeeId: number
  IsAbsolute?: boolean
  size?: [number, number]
}

interface IPhotoProps {
  backgroundImageUrl: string
  IsAbsolute: boolean
  size: [number, number]
  hasError: boolean
}

let chronosAuth = localStorage.getItem('token')
let webApiKey = localStorage.getItem('webApiKey')

export default function TrainerPhoto({ trainerEmployeeId, IsAbsolute = true, size = [50, 50] }: ITrainerPhotoProps) {
  const [hasError, setHasError] = useState(false)
  
  let backgroundImageUrl = useMemo(
    () =>
      `${process.env.REACT_APP_API}Employee/GetEmployeePhoto?employeeId=${trainerEmployeeId}&ChronosAuth=${chronosAuth}&WebApiKey=${webApiKey}`,
    [trainerEmployeeId]
  )

  useEffect(() => {
    setHasError(false)
    const img = new Image()
    img.onload = () => setHasError(false)
    img.onerror = () => setHasError(true)
    img.src = backgroundImageUrl
  }, [backgroundImageUrl])

  return <Photo IsAbsolute={IsAbsolute} size={size} backgroundImageUrl={backgroundImageUrl} hasError={hasError} />
}

const Photo = styled.div<IPhotoProps>`
  ${({ IsAbsolute }) =>
    IsAbsolute &&
    css`
      position: absolute;
      top: 25px;
      left: 125px;
      border: 2px solid #fff;
    `}
  background-image: ${({ backgroundImageUrl, hasError }) => 
    hasError ? 'none' : `url(${backgroundImageUrl})`};
  background-color: ${({ hasError }) => hasError ? '#e0e0e0' : 'transparent'};
  width: ${({ size }) => `${size[0]}px`};
  height: ${({ size }) => `${size[1]}px`};
  background-size: cover;
  background-position: center center;
  border-radius: 50%;
  border: 1px solid #ccc;
  display: flex;
  align-items: center;
  justify-content: center;
  
  ${({ hasError, size }) =>
    hasError &&
    css`
      &::before {
        content: '👤';
        font-size: ${size[0] * 0.5}px;
        opacity: 0.5;
      }
    `}
`
